import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.noInputRendering ? _c('div', [_vm._v("no input")]) : _vm.field.type === 'textarea' ? _c('div', [_c(VRow, [_c(VCol, [_vm.showRenderedMarkdown ? _c(VCard, {
    staticClass: "elevation-0 v-card-text-area mdbox",
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.itemValue || ''
    }
  })], 1)], 1) : _c(VCard, [_c(VTextarea, {
    attrs: {
      "value": _vm.fieldValue,
      "disabled": _vm.fieldIsDisabled,
      "label": _vm.fieldLabel,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rows": "7",
      "hide-details": "auto",
      "clearable": _vm.field.clearable,
      "name": _vm.field.key,
      "rules": _vm.field.rules,
      "loading": _vm.field.isLoading,
      "error-messages": _vm.field.errorMessages,
      "required": _vm.field.required
    },
    on: {
      "input": _vm.onInputChange
    }
  })], 1)], 1)], 1), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "disabled": !_vm.editMode,
      "label": _vm.$i18n_t('Common.mdeditor'),
      "color": _vm.color
    },
    model: {
      value: _vm.showRenderedMarkdown,
      callback: function ($$v) {
        _vm.showRenderedMarkdown = $$v;
      },
      expression: "showRenderedMarkdown"
    }
  })], 1) : _vm.field.type === 'select' ? _c(VSelect, {
    attrs: {
      "items": _vm.field.options,
      "label": _vm.fieldLabel,
      "value": _vm.fieldValue,
      "disabled": _vm.fieldIsDisabled,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": _vm.field.key,
      "color": _vm.color,
      "rules": _vm.combineRules(_vm.field),
      "item-text": "label",
      "item-value": "value",
      "loading": _vm.field.isLoading,
      "error-messages": _vm.field.errorMessages,
      "required": _vm.field.required,
      "multiple": _vm.field.multiple,
      "data-cy": _vm.field.dataCy
    },
    on: {
      "input": _vm.onInputChange
    }
  }) : _vm.field.type === 'autocomplete' ? _c(VAutocomplete, {
    attrs: {
      "items": _vm.field.options,
      "label": _vm.fieldLabel,
      "value": _vm.fieldValue,
      "disabled": _vm.fieldIsDisabled,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": _vm.field.key,
      "color": _vm.color,
      "rules": _vm.combineRules(_vm.field),
      "item-text": "label",
      "item-value": "value",
      "loading": _vm.field.isLoading,
      "error-messages": _vm.field.errorMessages,
      "required": _vm.field.required,
      "multiple": _vm.field.multiple,
      "data-cy": _vm.field.dataCy
    },
    on: {
      "input": _vm.onInputChange
    }
  }) : _vm.field.type === 'switch' ? _c(VSwitch, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showField,
      expression: "showField"
    }],
    attrs: {
      "label": _vm.fieldLabel,
      "input-value": _vm.fieldValue,
      "color": _vm.color,
      "disabled": _vm.fieldIsDisabled,
      "name": _vm.field.key,
      "loading": _vm.field.isLoading,
      "error-messages": _vm.field.errorMessages,
      "required": _vm.field.required,
      "data-cy": _vm.field.dataCy
    },
    on: {
      "change": _vm.onInputChange
    }
  }) : _vm.field.type === 'button' ? _c('core-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showField,
      expression: "showField"
    }],
    attrs: {
      "color": _vm.color,
      "iconColor": _vm.color,
      "prependIcon": _vm.field.icon,
      "disabled": _vm.fieldIsDisabled,
      "loading": _vm.field.isLoading,
      "solid-icon": !_vm.field.label,
      "data-cy": _vm.field.dataCy
    },
    on: {
      "click": () => _vm.field.onClick(_vm.updateItemByFieldKey)
    }
  }, [_vm.field.label ? _c('span', [_vm._v(_vm._s(_vm.field.label))]) : _vm._e()]) : _vm.field.type === 'code' ? _c('code', {
    style: _vm.field.fullWidth ? 'width: 100%;' : ''
  }, [_vm._v("\n    " + _vm._s(_vm.field.content) + "\n  ")]) : _vm.field.type === 'pre' ? _c('core-codemirror', {
    style: _vm.field.fullWidth ? 'width: 100%;' : '',
    attrs: {
      "value": _vm.field.content,
      "options": {
        readOnly: 'nocursor'
      }
    }
  }) : _vm.field.type === 'emptystate' ? _c('core-empty-state', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "color": _vm.color,
      "icon": _vm.field.icon
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.field.title))];
      },
      proxy: true
    }, {
      key: "button",
      fn: function () {
        return [_c('core-button', {
          staticClass: "mt-4",
          attrs: {
            "color": _vm.color,
            "data-cy": "empty-state-button",
            "disabled": _vm.fieldIsDisabled,
            "append-icon": "fa-plus"
          },
          on: {
            "click": function ($event) {
              return _vm.field.onClick(_vm.updateItemByFieldKey);
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.field.button) + "\n      ")])];
      },
      proxy: true
    }])
  }, [_c('p', [_vm._v(_vm._s(_vm.field.description))])]) : _c(VTextField, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showField,
      expression: "showField"
    }],
    attrs: {
      "label": _vm.fieldLabel,
      "value": _vm.fieldValue,
      "iconColor": _vm.color,
      "icon": _vm.field.icon,
      "color": _vm.color,
      "type": _vm.field.type,
      "disabled": _vm.fieldIsDisabled,
      "rules": _vm.combineRules(_vm.field),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": _vm.field.key,
      "clearable": _vm.field.clearable,
      "required": _vm.field.required,
      "loading": _vm.field.isLoading,
      "error-messages": _vm.field.errorMessages,
      "data-cy": _vm.field.dataCy
    },
    on: {
      "input": _vm.onInputChange
    }
  }), _vm._l(_vm.confirmationDialogs, function (dialog) {
    return _c('core-prompt', {
      key: dialog.identifier,
      attrs: {
        "title": dialog.title,
        "open": dialog.show,
        "buttons": [{
          text: dialog.cancelLabel || _vm.$i18n_t('Common.cancel'),
          emit: 'cancel'
        }, {
          text: dialog.confirmLabel || _vm.$i18n_t('Common.confirm'),
          emit: 'confirm'
        }]
      },
      on: {
        "cancel": () => dialog.resolve(false),
        "confirm": () => dialog.resolve(true)
      }
    }, [_vm._v("\n    " + _vm._s(dialog.message) + "\n  ")]);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };